export class CardsEventType {

	static STEPS = {
		LIST_CARDS: 'LIST_CARDS',
		DATA_CARDS: 'DATA_CARDS',
		DATA_CODE_CARDS: 'DATA_CODE_CARDS',
		CHANGE_PASS: 'CHANGE_PASS',
		CONFIRM_CARDS: 'CONFIRM_CARDS'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static ERROR = 'PACKAGE_ERROR';

	static ACTIONS = {
		BUTTONS: 'CARDS_BUTTONS'
	};
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/cards.event.type.ts